import { __awaiter, __generator, __values } from 'tslib';
import { Injectable, NgModule, defineInjectable, inject } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { S2AHttpClient } from '@s2a/ng-common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var EquipmentService = /** @class */ (function () {
    function EquipmentService(http) {
        this.http = http;
    }
    /**
     * @return {?}
     */
    EquipmentService.prototype.getLevels = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get('equipments/levels').toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        });
    };
    /**
     * @param {?} topLevel
     * @return {?}
     */
    EquipmentService.prototype.getEquipmentsByLevel = /**
     * @param {?} topLevel
     * @return {?}
     */
    function (topLevel) {
        return __awaiter(this, void 0, void 0, function () {
            var options, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {};
                        options.params = new HttpParams().set('level', topLevel.toLowerCase());
                        return [4 /*yield*/, this.http.get('equipments', options).toPromise()];
                    case 1:
                        result = _a.sent();
                        result = result.sort(function (a, b) {
                            return a.techDesc.localeCompare(b.techDesc);
                        });
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        });
    };
    /**
     * @param {?} eqipmentId
     * @return {?}
     */
    EquipmentService.prototype.getChildEquipments = /**
     * @param {?} eqipmentId
     * @return {?}
     */
    function (eqipmentId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get('equipments/' + eqipmentId + '/children').toPromise()];
                    case 1:
                        result = _a.sent();
                        result = result.sort(function (a, b) {
                            return a.techDesc.localeCompare(b.techDesc);
                        });
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    EquipmentService.prototype.getRootEquipmentTree = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get('equipments/roots/tree').toPromise()];
                    case 1:
                        result = _a.sent();
                        result = result.sort(function (a, b) {
                            return a.techDesc.localeCompare(b.techDesc);
                        });
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    EquipmentService.prototype.getAllEquipmentRecursiveFlat = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            /**
             * @param {?} equipment
             * @return {?}
             */
            function insertIntoFlatList(equipment) {
                var e_1, _a;
                try {
                    for (var equipment_1 = __values(equipment), equipment_1_1 = equipment_1.next(); !equipment_1_1.done; equipment_1_1 = equipment_1.next()) {
                        var part = equipment_1_1.value;
                        equipmentFlat.push(part);
                        if (part.children) {
                            insertIntoFlatList(part.children);
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (equipment_1_1 && !equipment_1_1.done && (_a = equipment_1.return)) _a.call(equipment_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            var equipmentTree, equipmentFlat;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRootEquipmentTree()];
                    case 1:
                        equipmentTree = (_a.sent()).filter(function (eq) { return eq.level === 'enterprise'; });
                        equipmentFlat = [];
                        insertIntoFlatList(equipmentTree);
                        return [2 /*return*/, equipmentFlat];
                }
            });
        });
    };
    /**
     * @param {?} equipment
     * @param {?=} parentId
     * @return {?}
     */
    EquipmentService.prototype.addEquipment = /**
     * @param {?} equipment
     * @param {?=} parentId
     * @return {?}
     */
    function (equipment, parentId) {
        return __awaiter(this, void 0, void 0, function () {
            var options, params, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {};
                        if (parentId) {
                            options.params = new HttpParams().set('parent_ids', parentId);
                        }
                        params = [{
                                techDesc: equipment.techDesc,
                                description: equipment.description,
                                level: equipment.level,
                                properties: equipment.properties
                            }];
                        return [4 /*yield*/, this.http.post('equipments', params, options).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result[0])];
                }
            });
        });
    };
    /**
     * @param {?} equipment
     * @return {?}
     */
    EquipmentService.prototype.updateEquipment = /**
     * @param {?} equipment
     * @return {?}
     */
    function (equipment) {
        return __awaiter(this, void 0, void 0, function () {
            var params, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            techDesc: equipment.techDesc,
                            description: equipment.description,
                            level: equipment.level,
                            properties: equipment.properties
                        };
                        return [4 /*yield*/, this.http.patch('equipments/' + equipment.equipmentId, params).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        });
    };
    /**
     * @param {?} equipment
     * @return {?}
     */
    EquipmentService.prototype.deleteEquipment = /**
     * @param {?} equipment
     * @return {?}
     */
    function (equipment) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.delete('equipments/' + equipment.equipmentId).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        });
    };
    EquipmentService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    EquipmentService.ctorParameters = function () { return [
        { type: S2AHttpClient }
    ]; };
    /** @nocollapse */ EquipmentService.ngInjectableDef = defineInjectable({ factory: function EquipmentService_Factory() { return new EquipmentService(inject(S2AHttpClient)); }, token: EquipmentService, providedIn: "root" });
    return EquipmentService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var NgEquipmentModule = /** @class */ (function () {
    function NgEquipmentModule() {
    }
    /**
     * @return {?}
     */
    NgEquipmentModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: NgEquipmentModule,
            providers: [
                EquipmentService
            ]
        };
    };
    NgEquipmentModule.decorators = [
        { type: NgModule, args: [{
                    imports: [],
                    declarations: [],
                    exports: []
                },] }
    ];
    return NgEquipmentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { NgEquipmentModule, EquipmentService };

//# sourceMappingURL=s2a-ng-equipment.js.map